import { gql } from "@apollo/client";

export const GET_DELEGACIONES_BY_USUARIO = gql`
query GetDelegacionesByUsuario (
    $idUsuario: Int!
) {
    allDelegacionesByUsuario (idUsuario: $idUsuario)
        {
            idDelegacion,
            idRegion,
            cod_Delegacion,
            descripcion
        }
}`;